import { Component } from '@angular/core';
import { TokenService } from '../services/token.service';

import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

declare var bootstrap: any; 

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  constructor(public tokenService: TokenService) { }
  
  /**
   * Bascule (toggle) l'Offcanvas Bootstrap manuellement en utilisant
   * l'objet 'bootstrap' global.
   */
  toggleSidebar(): void {
    const offcanvasElement = document.getElementById('sidebarOffcanvas');
    const bs = (window as any).bootstrap;

    if (!offcanvasElement) {
        console.error("Erreur: L'élément Offcanvas (ID: sidebarOffcanvas) est introuvable dans le DOM.");
        return;
    }
    
    if (bs && bs.Offcanvas) {
      const offcanvas = bs.Offcanvas.getOrCreateInstance(offcanvasElement);
      offcanvas.toggle(); 
    } else {
        console.error("Erreur: La librairie Bootstrap n'est pas disponible pour l'action de bascule. Vérifiez le chargement de bootstrap.bundle.min.js.");
    }
  }

}
